import { createTooltipTokens } from '../tokens/components.js';
import { SEMANTIC, type SemanticTokens } from '../tokens/semantic.js';

/**
 * Tooltip Component Configuration
 */
export function createTooltip(s: SemanticTokens) {
  const tooltipTokens = createTooltipTokens(s);
  return {
    root: {
      maxWidth: tooltipTokens.base.maxWidth,
      gutter: tooltipTokens.base.gutter,
      shadow: tooltipTokens.base.shadow,
      padding: `${tooltipTokens.base.paddingY} ${tooltipTokens.base.paddingX}`,
      borderRadius: tooltipTokens.base.radius,
    },
    colorScheme: {
      light: {
        root: {
          background: tooltipTokens.bgDefault,
          color: tooltipTokens.fgDefault,
        },
      },
    },
    css: () => `
      /* Wrap unbroken values and keep long tooltips within short viewports. */
      .p-tooltip-text {
        overflow-wrap: anywhere;
        word-break: break-word;
        white-space: pre-line;
        max-height: min(12rem, calc(100dvh - 2rem));
        overflow-y: auto;
      }
    `,
  };
}
export const tooltip = createTooltip(SEMANTIC);
